import React from 'react';
import PropTypes from 'prop-types';

const PaginatorSection = ({ onClick, page, total, label, disabled }) => (
  <div className="row padding-2">
    <p className="col-xs-12">
      <label className="pull-right">{`${page} de ${total}`}</label>
    </p>

    <p className="col-sm-offset-6 col-sm-6 col-xs-12">
      <div className="col-sm-6">
        {page !== 1 && (
          <button
            type="button"
            className="btn btn-default btn-block margin-top-05 pull-right"
            onClick={() => onClick(-1)}
            disabled={disabled}
          >
            {label.before}
          </button>
        )}
      </div>
      <div className="col-sm-6">
        {page !== total && (
          <button
            type="button"
            className="btn btn-default btn-block margin-top-05 pull-right"
            onClick={() => onClick(1)}
            disabled={disabled}
          >
            {label.next}
          </button>
        )}
      </div>
    </p>
  </div>
);

PaginatorSection.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.object,
  page: PropTypes.number,
  total: PropTypes.number,
};

export default PaginatorSection;
